import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=228a8712&scoped=true&"
import script from "./AgentList.vue?vue&type=script&lang=js&"
export * from "./AgentList.vue?vue&type=script&lang=js&"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=228a8712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a8712",
  null
  
)

export default component.exports